import store from "store2";

export const AUTH_TOKEN_STORAGE_KEY = "auth_token";
export const AUTH_TOKEN_PARTNER_STORAGE_KEY = "auth_token_partner";
export const USER_PHONE_STORAGE_KEY = "phone";
export const ACTIVE_ENTITY_ID = "activeEntityId";
export const SHOW_MODAL_OVERDUE_LOANS = "showModalOverdueLoans";
export const SHOW_MODAL_FORM_APPLICATION_REPEAT = "showModalFormApplicationRepeat";
export const SHORT_APP_ID = "shortAppId";
export const EQUIPMENT_TYPE = "property_type";

export const arenzaStorage = store.namespace("arenza");
